import type { BlackjackOperationsResponse } from "./api/client.js";

export const BLACKJACK_STALE_ROUND_MS = 60_000;
export const BLACKJACK_STALE_SNAPSHOT_MS = 30_000;

export function blackjackAlerts(data: BlackjackOperationsResponse, now = Date.now()) {
  const alerts: { message: string; severity: "critical" | "high" }[] = [];
  if (now - new Date(data.sampledAt).getTime() >= BLACKJACK_STALE_SNAPSHOT_MS) {
    alerts.push({ message: "Blackjack operations snapshot is stale", severity: "high" });
  }
  if (data.status === "unavailable") {
    alerts.push({ message: "Blackjack authority is unavailable", severity: "critical" });
  }
  const overdue = data.tables.filter(
    (table) => table.deadlineAtMs !== null && table.deadlineAtMs <= now,
  ).length;
  if (overdue > 0) {
    alerts.push({ message: `${overdue} Blackjack table deadline overdue`, severity: "high" });
  }
  const stalled = data.tables.filter(
    (table) =>
      table.currentRound && now - new Date(table.updatedAt).getTime() >= BLACKJACK_STALE_ROUND_MS,
  ).length;
  if (stalled > 0) {
    alerts.push({ message: `${stalled} Blackjack round has no fresh state`, severity: "high" });
  }
  const expiredLeases = data.tables
    .flatMap((table) => table.seats)
    .filter(
      (seat) => seat.connected && seat.leaseExpiresAtMs !== null && seat.leaseExpiresAtMs <= now,
    ).length;
  if (expiredLeases > 0) {
    alerts.push({
      message: `${expiredLeases} connected Blackjack seat${expiredLeases === 1 ? " has" : "s have"} an expired lease`,
      severity: "high",
    });
  }
  return alerts;
}
